export const config = {
     DB_ENDPOINT : 'https://ta-user-feedback.firebaseio.com/reader-estimates'

}
